export enum SortKeysEnum {
  DATE = "date",
  PRICE = "price",
  AMOUNT = "amount",
}
